import React, { Dispatch, SetStateAction } from 'react';

type TBackgroundData = {
    img: string;
    backgroundColor: string;
    name: string;
    price: number;
    groupName: string;
    isSeamless: boolean;
    isSeamlessMode: boolean;
    items: TBackgroundDataItem[];
};

export type TBackgroundDataItem = {
    price: number;
    premPrice: number;
    groupName: string;
    selectedImg: string;
    isPrem: boolean;
    isSeamlessMode: boolean;
    excludedOptions: any;
    installPrice: number;
    minInstallPrice: number;
    examplePrice: number;
    exampleExtraPrice: number;
    id: string;
    colors: {
        img: string;
        name: string;
    }[];
    premColors: {
        img: string;
        name: string;
    }[];
};

type CanvasBackgroundContextType = {
    backgroundData: TBackgroundData;

    setBackgroundData: Dispatch<SetStateAction<{
        img: string;
        backgroundColor: string;
        name: string;
        price: number;
        groupName: string;
        isSeamless: boolean;
        isSeamlessMode: boolean;
        items: {
            price: number;
            premPrice: number;
            groupName: string;
            selectedImg: string;
            isPrem: boolean;
            isSeamlessMode: boolean;
            excludedOptions: any;
            installPrice: number;
            minInstallPrice: number;
            examplePrice: number;
            exampleExtraPrice: number;
            id: string;
            colors: {
                img: string;
                name: string;
            }[];
            premColors: {
                img: string;
                name: string;
            }[];
        }[];
    }>>;
};

export const canvasBackgroundContext = React.createContext<CanvasBackgroundContextType>({
    backgroundData: {
        img: '',
        backgroundColor: '',
        name: '',
        price: 0,
        groupName: '',
        isSeamless: false,
        isSeamlessMode: false,
        items: [
            {
                price: 0,
                premPrice: 0,
                groupName: '',
                selectedImg: '',
                isPrem: false,
                isSeamlessMode: false,
                excludedOptions: false,
                installPrice: 0,
                minInstallPrice: 0,
                examplePrice: 0,
                exampleExtraPrice: 0,
                id: '',
                colors: [
                    {
                        img: '',
                        name: '',
                    },
                ],
                premColors: [
                    {
                        img: '',
                        name: '',
                    },
                ],
            },
        ],
    },

    setBackgroundData: () => {
    },
});
